import { get } from '..';

const getNotificationGroups = (groupId: string) => get(
  `users/v2/user-groups/notifications/${groupId}`,
);

export default getNotificationGroups;
